import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RunnerSchema } from './shapes';

/** Every known runner (a handful — filters run client-side). */
export const listRunners = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/runners',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(RunnerSchema) }),
});
